'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';
import EventView from '../views/EventView.vue';
import EventManageView from '../views/ManageEventView.vue';
import {
  eventAnglerRoutes,
  eventManageAnglerRoutes,
} from '../../angler/routes/angler-routes';
import {
  eventDrawRoutes,
  eventManageDrawRoutes,
} from '../../draw/routes/draw-routes';
import {
  eventGroupRoutes,
  eventManageGroupRoutes,
} from '../../group/routes/group-routes';
import {
  eventRegistrationRoutes,
  eventManageRegistrationRoutes,
} from '../../registration/routes/registration-routes';
import {
  eventResultRoutes,
  eventManageResultRoutes,
} from '../../result/routes/result-routes';
import {
  eventRotationRoutes,
  eventManageRotationRoutes,
} from '../../rotation/routes/rotation-routes';
import {
  eventScoreRoutes,
  eventManageScoreRoutes,
} from '../../score/routes/score-routes';
import {
  eventSectorRoutes,
  eventManageSectorRoutes,
} from '../../sector/routes/sector-routes';
import {
  eventSecurityRoutes,
  eventManageSecurityRoutes,
} from '../../security/routes/security-routes';
import {
  eventSessionRoutes,
  eventManageSessionRoutes,
} from '../../session/routes/session-routes';
import {
  eventManageSettingRoutes,
} from '../../setting/routes/setting-routes';
import {
  eventTeamRoutes,
  eventManageTeamRoutes,
} from '../../team/routes/team-routes';

// Event routes
let eventChildRoutes = [
  {
    path: '',
    name: 'event.detail',
    props: true,
    component: () => import('../views/EventDetailView.vue'),
  },
];
eventChildRoutes = eventChildRoutes.concat(
  eventAnglerRoutes,
  eventDrawRoutes,
  eventGroupRoutes,
  eventRegistrationRoutes,
  eventResultRoutes,
  eventRotationRoutes,
  eventScoreRoutes,
  eventSectorRoutes,
  eventSecurityRoutes,
  eventSessionRoutes,
  eventTeamRoutes,
);

// Manage event routes
let manageChildRoutes = [
  {
    path: '',
    name: 'event.manage.detail',
    props: true,
    component: () => import('../views/ManageEventHomeView.vue'),
  },
  {
    path: 'edit',
    name: 'event.manage.edit',
    props: true,
    component: () => import('../views/ManageEventEditView.vue'),
  },
];
manageChildRoutes = manageChildRoutes.concat(
  eventManageAnglerRoutes,
  eventManageDrawRoutes,
  eventManageGroupRoutes,
  eventManageRegistrationRoutes,
  eventManageResultRoutes,
  eventManageRotationRoutes,
  eventManageScoreRoutes,
  eventManageSectorRoutes,
  eventManageSecurityRoutes,
  eventManageSessionRoutes,
  eventManageSettingRoutes,
  eventManageTeamRoutes,
);

export const eventRoutes = [
  {
    path: '/events',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.list',
        component: () => import('../views/EventListView.vue'),
      },
      {
        path: 'add',
        name: 'event.add',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/EventAddView.vue'),
      },
      {
        path: ':eventUrl/manage',
        component: EventManageView,
        props: true,
        meta: {
          requiresAuth: true,
          layout: 'EventManagementLayout',
        },
        children: manageChildRoutes,
      },
      {
        path: ':eventUrl',
        component: EventView,
        props: true,
        children: eventChildRoutes,
      },
    ],
  },
];
